module.exports = ".agencymatrix_integration .account_options {\n    border-bottom: 0;\n}"